
import { useMemo } from "react";
import dayjs from "dayjs";
import { DATE_FORMAT } from "constant/date";

const useDaysArray = (yearMonth: string) => {
  return useMemo(() => {
    const daysInMonth = dayjs(yearMonth).daysInMonth();

    return Array.from({ length: daysInMonth }, (_, i) => {
      const date = dayjs(`${yearMonth}/${i + 1}`);

      return {
        dayOfMonth: i + 1,
        dayOfWeek: date.locale("ja").format("dd"),
        date: date.format(DATE_FORMAT),
      };
    });
  }, [yearMonth]);
};

export default useDaysArray;
